module.exports = __webpack_public_path__ + "static/media/planet-background.571585c3.jpg";